import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoginModuleComponent } from './login-module.component';
import { SignInPageComponent } from './signinpage/signinpage.component';
import { RouterModule, Routes } from '@angular/router';
import { ForGotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { RegisterPageNRHComponent } from './registerpagenrh/registerpagenrh.component';
import { SignUpPageComponent } from './signuppage/signuppage.component';
import { SignUpRegComponent } from './signupreg/signupreg.component';
import { SignUpHosComponent } from './signuphos/signuphos.component';
import { SelBranchRoleComponent } from './branchandrole/branchrole.component';
import { SpinnerService } from '../app/ncs/services/spinner.service';
import { NgxSpinnerModule } from "ngx-spinner";
import { CustomerLoginComponent } from './signinpage/custsigninpage.component';
import { SharedModule } from '../app/shared/shared.module';
// Trigger Angular build

const routes: Routes = [
  {
    path: 'signinpage', component: SignInPageComponent
  },
  {
    path: 'forgotpassword', component: ForGotPasswordComponent
  },
  {
    path: 'registernrh', component: RegisterPageNRHComponent
  },
  {
    path: 'signuppage', component: SignUpPageComponent
  },
  {
    path: 'signupreg', component: SignUpRegComponent
  },
  {
    path: 'signuphos', component: SignUpHosComponent
  },
  {
    path: 'branchrole', component: SelBranchRoleComponent
  },
  {
    path: 'Changepassword', component: ForGotPasswordComponent
  }
];

@NgModule({
  declarations: [
    LoginModuleComponent,
    SignInPageComponent,
    ForGotPasswordComponent,
    RegisterPageNRHComponent,
    SignUpPageComponent,
    SignUpRegComponent,
    SignUpHosComponent,
    SelBranchRoleComponent,
    CustomerLoginComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxSpinnerModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    SpinnerService
  ]
})
export class LoginModule { }
